import { request } from '@/utils/request'

const prefix = '/rest/roles'

export function fetchRoleUsers (role) {
  return request({
    url: `${prefix}/role-users`,
    method: 'post',
    data: {role}
  })
}
export function getRoles () {
  return request({
    url: '/app/users/roles',
    method: 'get'
  }).then(roles => {
    return roles.map(r => {
      return { value: r.nameEn, label: r.name }
    })
  })
}



// WEBPACK FOOTER //
// ./src/rest/roles.js